import Http from './../http';

const prefix = '/auto-tags';

export const getTags = () => Http.authApi().get(`${prefix}/getTags`);


export const getGroups = () => Http.authApi().get(`${prefix}/getGroups`);


export const storeUserTags = (params) => Http.authApi().post(`${prefix}/storeUserTags`, params);


export const storeGroup = (params) => Http.authApi().post(`${prefix}/storeGroup`, params);


export const deleteGroup = (id) => Http.authApi().get(`${prefix}/deleteGroup/${id}`);


export const getTagsForLink = () => Http.authApi().get(`${prefix}/tagsForLink`);




// WEBPACK FOOTER //
// ./src/js/services/editor/autotag.js